:root {
  /* Mobile safe areas (Discord Activity + iOS fallback).
     Discord injects --discord-safe-area-inset-*; fall back to env() for
     iOS Safari / local dev outside Discord. Requires viewport-fit=cover. */
  --sait: var(--discord-safe-area-inset-top, env(safe-area-inset-top, 0px));
  --saib: var(--discord-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
  --sail: var(--discord-safe-area-inset-left, env(safe-area-inset-left, 0px));
  --sair: var(--discord-safe-area-inset-right, env(safe-area-inset-right, 0px));
  --cocoa: #2a1a12;
  --cocoa-deep: #1c110b;
  --wood: #5a3421;
  --wood-dark: #3a2115;
  --cream: #ffdf9e;
  --paper: #fff3d0;
  --paper-deep: #ffe9b0;
  --crust: #ff9f43;
  --crust-deep: #d96f1e;
  --chip: #ffd23f;
  --chip-deep: #b45309;
  --berry: #8b5cf6;
  --berry-deep: #5b3bb5;
  --cherry: #ff5a5a;
  --mint: #4ade80;
  --mint-deep: #15803d;
  --ink: #3a2115;
  --ink-soft: #6b4426;
  --outline: 4px solid var(--ink);
  --r-card: 16px;
  --r-pill: 999px;
  --shadow-hard: 0 4px 0 var(--ink);
  --shadow-pop: 0 4px 0 var(--ink), 0 10px 24px rgba(0,0,0,.45);
  --font-pixel: "Press Start 2P", "VT323", "Courier New", monospace;
  --font-round: "Trebuchet MS", "Segoe UI", system-ui, sans-serif;
  --fx-floater: 950ms;
  --fx-ripple: 950ms;
  --fx-crumb: 950ms;
  --fx-lunge: 180ms;
  --fx-press: 120ms;
  --fx-bump: 600ms;
  --fx-auto: 280ms;
  --fx-floater-reduced: 400ms;
  --fx-ripple-reduced: 200ms;
  --fx-crumb-reduced: 200ms;
}
html, body, #root { height: 100%; }
html, body { overflow-x: clip; max-width: 100%; }
body {
  margin: 0;
  background: var(--cocoa) radial-gradient(circle at 50% -10%, #4a2c1a 0, var(--cocoa) 55%, var(--cocoa-deep) 100%);
  color: var(--paper);
  font-family: var(--font-round);
  -webkit-font-smoothing: antialiased;
}
img, select { max-width: 100%; }
button { font-family: inherit; }
button:focus-visible, a:focus-visible, select:focus-visible {
  outline: 3px solid var(--chip);
  outline-offset: 2px;
}
.px-num, .bk-cookie-pill .num, .bk-bignum, .cb-big, .bk-evtime, .cb-timer, .bk-float, .cb-cost {
  font-family: var(--font-pixel);
  letter-spacing: .02em;
}
::selection { background: var(--chip); color: var(--ink); }
